import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRubric = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_10035_25214",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_10035_25214)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M3.75 17.0994V2.90063H16.25V10.625H5V12.6123H9.375V13.8621H5V15.8494H9.375V17.0994H3.75ZM12.8333 17.0994L10.7885 15.0544L11.6667 14.1763L12.8333 15.3429L15.7917 12.3846L16.6698 13.2627L12.8333 17.0994ZM5 9.37501H9.375V7.38772H5V9.37501ZM10.625 9.37501H15V7.38772H10.625V9.37501ZM5 6.13793H9.375V4.15063H5V6.13793ZM10.625 6.13793H15V4.15063H10.625V6.13793Z",
			fill: "#064C68"
		})
	})]
});
export default SvgRubric;
